import React from 'react';
import { NavBarTypes } from '../navBarTypes';
import { Icon } from '../../../../../utilities/icomoon-css';

export const DashboardAndLogOutSection = ({
  onClickHandler,
  iconName,
  label = '',
}: NavBarTypes.TSignInAvatarHelpersTypes) => {
  return (
    <div className="logOutSection" onClick={onClickHandler}>
      <div className="labelSection">
        <Icon name={iconName} size={24} title={iconName} />
        <p className="pl-3 subtitle2">{label}</p>
      </div>
    </div>
  );
};

export const getCurrentLocation = (
  locationDetails: any,
  currentFacilityId: string
) => {
  if (locationDetails && locationDetails.length > 1) {
    return locationDetails.filter(
      (eachLocation: any) => eachLocation?.facility_sms_id === currentFacilityId
    )[0];
  } else {
    return locationDetails?.[0];
  }
};
